// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useCreateSubmission } from '@hooks/mutations/ledger/useSubmission';
import { BurnRequest } from '@daml.js/utility-registry-v0/lib/Utility/Registry/V0/Holding/Burn';
import { ERR_REQ_BURN, SUC_REQ_BURN } from '../../../../utils/strings';

export const useRequestBurn = () => {
  const { submit } = useCreateSubmission(BurnRequest, SUC_REQ_BURN, ERR_REQ_BURN);
  return submit;
};
